export const _tokenName = "hrd.user.token";
export const _refreshTokenName = "hrd.user.refresh.token";
export const _languageName = "hrd.user.language";
export const _hasSignedIn = "hrd.user.hasSignEdIn";

export const saveLocalData = (name: string, data: any) => {
    localStorage.setItem(name , JSON.stringify(data));
}

export const deleteLocalData = (name: string) => {
    localStorage.removeItem(name);
}

export const getLocalData = (name: string) => {
    const data = localStorage.getItem(name);

    if(data) {
        return JSON.parse(data);
    }
    return null;
}